import Dexie from "dexie";
import db from "../Db";

var UpdateConcaire = Dexie.async(function* (CONCAIRE) {
  yield db.open();
  yield db.CONCAIRE.put(CONCAIRE);
});

export default UpdateConcaire;
